import React, { Component } from 'react'
import { Card, CardBody, CardGroup, Col, Container, Row } from 'reactstrap'

import logo from '../../../assets/img/brand/Logo.png'

class Help extends Component {
  render () {
    return (
      <div className='app flex-row align-items-center login-background'>
        <Container>
          <Row className='justify-content-center'>
            <Col md='10' lg='5' xl='5'>
              <center><img src={logo} width='500px' alt='SERA Logo' /></center>
              <CardGroup>
                <Card className='p-4 login-boxshadow'>
                  <CardBody>
                    <p className='help-box'>Si necesitas ayuda con el app o la plataforma, escríbenos un email
                    a <a href='mailto:seraconsultants@gmail.com'>seraconsultants@gmail.com</a> y
                    te estaremos ayudando en las próximas 24-48 horas laborables.</p>
                  </CardBody>
                </Card>
              </CardGroup>
            </Col>
          </Row>
        </Container>
      </div>
    )
  }

}

export default Help
